"use strict";
import React from "react";
import { createRoot } from "react-dom/client";
import Accordion from "./Accordion";
import ContactForm from "./ContactForm";
import DesktopMenu from "./DesktopMenu";
import EpiForms from "./EpiForms";
import HeroBlockHeight from "./HeroBlockHeight";
import MapPage from "./MapPage/MapPage";
import MobileMenu from "./MobileMenu";
import OfferArchive from "./OfferArchive";
import Recipe from "./Recipe";
import StoreBlock from "./StoreBlock";
import SubscribeForm from "./SubscribeForm";
import ToggleCard from "./ToggleCard";
import VideoEmbed from "./VideoEmbed";
import WeeklyOffers from "./WeeklyOffers";
import YouTube from "./YouTube";
import StoreSelector from "./react/components/StoreSelector";
import WeeklyOffersSelection from "./react/components/WeeklyOffersSelection";
import TjekWidget from "./TjekWidget";
import News from "./News";
import OpenStatus from "./OpenStatus";

document.addEventListener("DOMContentLoaded", function () {
    new Accordion();
    new DesktopMenu();
    new MobileMenu();
    new YouTube();
    new Recipe();
    new HeroBlockHeight();
    new SubscribeForm();
    new ContactForm();
    new OfferArchive();
    new StoreBlock();
    new WeeklyOffers();
    new EpiForms();
    new MapPage();
    new ToggleCard();
    new VideoEmbed();
    new TjekWidget();
    new News();
    new OpenStatus();

    const storeSelectorContainer = document.querySelector(
        "#store-selector-container",
    ) as HTMLElement;

    if (storeSelectorContainer) {
        createRoot(storeSelectorContainer).render(<StoreSelector />);
    }

    const weeklyOffersSelectionContainer = document.getElementById(
        "weekly-offers-selection-container",
    ) as HTMLElement;

    if (weeklyOffersSelectionContainer) {
        const translations = {
            i18nButtonText:
                weeklyOffersSelectionContainer?.dataset.i18nButtonText ||
                "Välj butik",
            i18nInputPlaceholder:
                weeklyOffersSelectionContainer?.dataset.i18nInputPlaceholder ||
                "Sök butik",
            i18nNoResults:
                weeklyOffersSelectionContainer?.dataset.i18nNoResults ||
                "Din sökning gav inga resultat",
        };
        createRoot(weeklyOffersSelectionContainer).render(
            <WeeklyOffersSelection translations={translations} />,
        );
    }
});
